import { render } from "./quoted-opportunity.vue?vue&type=template&id=5b387cf7&scoped=true"
import script from "./quoted-opportunity.vue?vue&type=script&lang=js"
export * from "./quoted-opportunity.vue?vue&type=script&lang=js"

import "./quoted-opportunity.vue?vue&type=style&index=0&id=5b387cf7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b387cf7"]])

export default __exports__